export enum HistoryFilter {
  ALL,
  PLAYED,
  BENEFITED,
}

export class HistoryFilterOptions {
  page: number;
  filter: HistoryFilter;
  total: bigint;

  constructor(page: number, filter: HistoryFilter, total: bigint) {
    this.page = page;
    this.filter = filter;
    this.total = total;
  }

  copyWithPage(page: number): HistoryFilterOptions {
    return new HistoryFilterOptions(page, this.filter, this.total);
  }
}
